/**
 * A pasted connection string, collapsed (Option C final UX review UX-03): the start filter and the pane's paste box show
 * this chip instead of the text once a paste is read, so the string — a password in it included — is never on screen.
 * The text stays in the dialog's state for Continue / Apply; the chip names only the engine or format. Its ✕ clears the
 * string (`ui:connection_string_cleared`), as Backspace in the empty input beside it does; typing or pasting replaces it.
 */
import { ClipboardPaste, X } from 'lucide-react';

type Props = { id: string; label: string; onClear: () => void };

export function PastedStringChip({ id, label, onClear }: Props) {
  return (
    <span
      id={id}
      className="inline-flex min-w-0 max-w-[70%] shrink items-center gap-1.5 rounded-md border border-primary/30 bg-primary/10 py-0.5 pl-2 pr-0.5 text-xs font-medium text-foreground"
      data-testid="connection-string-chip"
    >
      <ClipboardPaste className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden />
      <span className="truncate">{label}</span>
      <button
        type="button"
        aria-label="Clear the pasted connection string"
        onMouseDown={(event) => event.preventDefault()}
        onClick={onClear}
        className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded text-muted-foreground outline-none hover:bg-primary/15 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring"
        data-testid="connection-string-chip-clear"
      >
        <X className="h-3.5 w-3.5" aria-hidden />
      </button>
    </span>
  );
}
